import { carouselData } from '@/mocks/homepage';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-4">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-focus-2-line text-sm"></i>
            </div>
            精彩专题
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 font-heading mb-3">
            深度影视专题策划
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            91在线视频编辑团队倾力打造，每个专题都是一次独特的观影旅程
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {carouselData.map((item) => (
            <article
              key={item.id}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-accent-200 transition-all cursor-pointer flex flex-col"
            >
              <div className="aspect-[16/9] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <span className="inline-block self-start px-2.5 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-xs font-medium mb-3 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="text-lg font-bold text-foreground-900 font-heading mb-2 group-hover:text-accent-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                  {item.desc}
                </p>
                <div className="mt-4 flex items-center gap-1 text-accent-600 text-sm font-medium cursor-pointer">
                  <span className="whitespace-nowrap">探索专题</span>
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}